module.exports = __webpack_public_path__ + "static/media/add_app_search.d787dffe.png";